module.exports = __webpack_public_path__ + "static/media/fog.svg.b23e6e59.png";